import React from 'react';
import { X, AlertCircle } from 'lucide-react';
import { ROUTINES_API, fetchWithAuth } from "../../utils/api";

const DeleteModal = ({ isOpen, onClose, routine, onDelete, isDarkMode }) => {
  const handleDelete = async () => {
    try {
      await fetchWithAuth(`${ROUTINES_API}/${routine.routineId}`, {
        method: "DELETE"
      });

      // Call the onDelete callback to update the UI
      onDelete(routine.routineId);
      onClose();
    } catch (err) {
      console.error("Error deleting routine:", err);
      alert(`Error: ${err.message}`);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4">
        <div className={`relative w-full max-w-md ${
          isDarkMode 
            ? 'bg-[#1a1f2d]/90 backdrop-blur-xl border border-white/5 shadow-2xl'
            : 'bg-base-100 shadow-lg'
        } rounded-lg animate-scale-in`}>
          <div className={`flex items-center justify-between p-4 ${
            isDarkMode 
              ? 'border-b border-white/5' 
              : 'border-b border-base-200'
          }`}>
            <div className="flex items-center">
              <AlertCircle className={`h-6 w-6 ${isDarkMode ? 'text-red-400' : 'text-error'} mr-2`} />
              <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-base-content'}`}>
                Delete Routine
              </h3>
            </div>
            <button
              onClick={onClose}
              className={`p-2 rounded-lg transition-colors ${
                isDarkMode 
                  ? 'text-gray-400 hover:bg-white/10'
                  : 'text-base-content/70 hover:text-base-content hover:bg-base-200'
              }`}
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          
          <div className="p-6">
            <p className={`${isDarkMode ? 'text-gray-300' : 'text-base-content/80'}`}>
              Are you sure you want to delete <span className="font-semibold">{routine?.title}</span>? 
              This action cannot be undone.
            </p>
            
            <div className="mt-6 flex justify-end space-x-3">
              <button
                onClick={onClose}
                className={`px-4 py-2 rounded-lg transition-colors ${
                  isDarkMode 
                    ? 'bg-[#252D42] hover:bg-[#2A3450] text-white border border-white/5'
                    : 'btn btn-ghost'
                }`}
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className={`px-4 py-2 rounded-lg transition-colors ${
                  isDarkMode 
                    ? 'bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/20'
                    : 'btn btn-error'
                }`}
              >
                Delete Routine
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;